import {FC} from 'react'
import {Col, Row} from 'react-bootstrap'
import {shortenLargeNumber} from '../../../../libs/misc'
import {SimulationResponse} from '../core/_models'
import {calcImportPct} from '../core/_transforms'

type Props = {
  result: SimulationResponse
  onScrollToFlows: () => void
  onScrollToEconomies: () => void
}

const SummaryCard: FC<Props> = ({result, onScrollToFlows, onScrollToEconomies}) => {
  const {summary, meta, current_trade} = result
  const total = summary.result_sum_trade_effect_total
  const isLoss = total < 0
  const pct = calcImportPct(summary, current_trade)
  const flowsCount = meta.counter_calc_trade_creation_not_null || 0
  const economiesCount = Object.keys(result.partners_affected.trade_creation || {}).length

  const creation = summary.result_sum_trade_creation
  const diversion = summary.result_sum_trade_diversion
  const signed = (v: number) => `US$ ${shortenLargeNumber(v)}`
  const colorClass = (v: number) => (v < 0 ? 'kt-font-danger' : 'kt-font-success')

  return (
    <Row className='mb-4'>
      <Col md={6}>
        <div
          className={`notice d-flex align-items-center rounded border p-6 h-100 ${
            isLoss ? 'border-danger' : 'border-success'
          }`}
        >
          <div>
            <h4 className={colorClass(total)}>Total trade effect: {signed(total)}</h4>
            <div className='text-gray-700'>
              Trade creation: <span className={colorClass(creation)}>{signed(creation)}</span> ·
              Trade diversion: <span className={colorClass(diversion)}>{signed(diversion)}</span>
            </div>
            <div className='text-muted'>
              ≈ {pct} of current imports (US$ {shortenLargeNumber(current_trade.total_sum)})
            </div>
          </div>
        </div>
      </Col>
      <Col md={6}>
        <div
          className='notice d-flex rounded border p-6 mb-4 cursor-pointer'
          onClick={onScrollToFlows}
        >
          <div>{flowsCount} commodity flows impacted →</div>
        </div>
        <div
          className='notice d-flex rounded border p-6 cursor-pointer'
          onClick={onScrollToEconomies}
        >
          <div>Reduced exports to {economiesCount} economies →</div>
        </div>
      </Col>
    </Row>
  )
}

export default SummaryCard
